"use client"
import { createTheme } from "@mui/material/styles"
import { frFR } from "@mui/material/locale"

const theme = createTheme(
  {
    palette: {
      primary: {
        main: "#ea4c9791", // rose plus péchu
        light: "#ea4c97ba",
        dark: "#ea4c97",
        contrastText: "#fff",
      },
      secondary: {
        main: "#94A897", // Sage green
        light: "#B6C3B7",
        dark: "#748A76",
        contrastText: "#fff",
      },
      background: {
        default: "#FFFAF5", // Warm cream
        paper: "#FFF",
      },
      error: {
        main: "#CF7F7F", // Soft red
      },
      text: {
        primary: "#084272",
        secondary: "#084272a1",
      },
    },
    typography: {
      fontFamily: "var(--font-primary), sans-serif",
      h1: {
        fontFamily: "var(--font-display), serif",
        fontWeight: 400,
        fontSize: "3.5rem",
        lineHeight: 1.2,
        letterSpacing: "0.02em",
      },
      h2: {
        fontFamily: "var(--font-display), serif",
        fontWeight: 400,
        fontSize: "2.5rem",
        lineHeight: 1.3,
        letterSpacing: "0.02em",
      },
      h3: {
        fontFamily: "var(--font-display), serif",
        fontWeight: 400,
        fontSize: "2rem",
        lineHeight: 1.3,
      },
      h4: {
        fontFamily: "var(--font-display), serif",
        fontWeight: 400,
        fontSize: "1.5rem",
        lineHeight: 1.4,
      },
      h5: {
        fontFamily: "var(--font-display), serif",
        fontWeight: 400,
        fontSize: "1.25rem",
        lineHeight: 1.4,
      },
      h6: {
        fontFamily: "var(--font-display), serif",
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.5,
      },
      body1: {
        fontWeight: 400,
        fontSize: "1rem",
        lineHeight: 1.5,
      },
      body2: {
        fontWeight: 400,
        fontSize: "0.875rem",
        lineHeight: 1.5,
      },
      button: {
        fontWeight: 500,
        fontSize: "0.875rem",
        textTransform: "none",
        letterSpacing: "0.02em",
      },
    },
    shape: {
      borderRadius: 8,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          ":root": {
            "--foreground-rgb": "0, 0, 0",
            "--background-start-rgb": "255, 255, 255",
            "--background-end-rgb": "255, 250, 245",
            "--primary-color": "234, 76, 151, 0.7",
            "--secondary-color": "148, 168, 151",
            "--primary-color-without-transparancy": "234, 76, 151",
            "--accent-color": "226, 205, 175",
            "--text-color": "8, 66, 114",
          },
          body: {
            margin: 0,
            padding: 0,
            color: "rgb(var(--text-color))",
            background:
              "linear-gradient(to bottom, rgb(var(--background-start-rgb)), rgb(var(--background-end-rgb)))",
            minHeight: "100vh",
          },
          ".scroll-down": {
            animation: "bounce 2s infinite",
          },
          ".timeline-item": {
            position: "relative",
            paddingLeft: "30px",
            marginBottom: "50px",
            "&::before": {
              content: '""',
              position: "absolute",
              left: 0,
              top: "6px",
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor:
                "rgb(var(--primary-color-without-transparancy),0.5)",
            },
            "&::after": {
              content: '""',
              position: "absolute",
              left: "5px",
              top: "24px",
              width: "2px",
              height: "calc(100% + 30px)",
              backgroundColor:
                "rgba(var(--primary-color-without-transparancy), 0.5)",
            },
            "&:last-child::after": {
              display: "none",
            },
          },
          ".gallery-img": {
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            "&:hover": {
              transform: "scale(1.02)",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
            },
          },
          ".countdown-item": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "70px",
            height: "70px",
            borderRadius: "50%",
            backgroundColor:
              "rgba(var(--primary-color-without-transparancy),0.1)",
            margin: "0 10px",
            "@media (min-width: 640px)": {
              width: "90px",
              height: "90px",
              margin: "0 15px",
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
            borderRadius: 12,
          },
        },
      },
    },
  },
  frFR,
)

export default theme
